import { useQuery } from '@tanstack/react-query';
import { vehicleRepository } from '../../repositories/vehicle-repository';

export const useFetchBrands = () =>
  useQuery(['vehicle-brands'], () => vehicleRepository.getVehicleBrands());
